{
	"language": {
		"select": "选择语言",
		"sectionTitle": "语言",
		"changeSuccess": "语言更改成功"
	},
	"assistant": {
		"composer": {
			"placeholder": "向{{assistantName}}提问",
			"disclaimer": "{{assistantName}}可能会出错。请核实重要信息。"
		},
		"greeting": {
			"initialMessage": "👋 你好，我是**{{assistantName}}**学习助手，我会帮助你更好地备考**{{context}}**！让我们具体分析你在**{{topic}}**方面回答的题目。",
			"starter": "你好，我是**{{assistantName}}**。有什么可以帮你？"
		},
		"chips": {
			"askYourOwn": "提出你自己的问题",
			"askFollowUp": "提出后续问题"
		},
		"emptyState": {
			"title": "{{assistantName}}是您的AI学习助手",
			"contextSubtitle": "可询问任何与{{context}}相关的问题",
			"activateSubtitle": "回答问题后即可使用{{assistantName}}"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "快速学习",
			"examInfo": {
				"subtitle": {
					"setExamDate": "设置考试日期",
					"examDateWithValue": "考试日期：<date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "可以更好",
				"itsAwesome": "很棒"
			},
			"title": "你很棒！",
			"body": "很高兴看到您对学习的投入！您对应用程序的体验如何？您愿意分享您的想法并留下评价吗？",
			"cta": "稍后再说"
		},
		"actions": {
			"studyWeak": "练习薄弱领域",
			"viewProgress": "查看进度",
			"seeRank": "查看我的排名",
			"seeRankings": "查看排行榜",
			"unlock": "解锁高级内容",
			"unlockTooltip": "通过解锁高级内容，您将获得独家功能和高级学习材料",
			"startCustomSession": "开始自定义会话",
			"startCustomSessionTooltip": "开始一个自定义会话，专注于您的学习",
			"takeDiagnostic": "进行诊断",
			"takeDiagnosticTooltip": "进行诊断以评估您的当前水平并相应地定制您的学习计划",
			"viewDiagnostic": "查看诊断结果",
			"viewDiagnosticTooltip": "查看您的诊断结果以了解您的优势和需要改进的地方",
			"viewPodcasts": "听播客",
			"viewPodcastsTooltip": "访问教育播客以增强您的学习体验",
			"upgradeToPremium": "升级到高级版",
			"upgradeToPremiumTooltip": "升级到高级版以访问所有内容和功能",
			"extendAccess": "延长访问",
			"extendAccessTooltip": "延长您对高级内容的访问权限",
			"setExamDate": "设置考试日期",
			"setExamDateTooltip": "设置您的考试日期以跟踪您的进度并准备您的考试"
		},
		"exam": {
			"daysAgo_one": "{{count}}天前",
			"daysAgo_other": "{{count}}天前",
			"untilExam_one": "距离考试还有{{count}}天",
			"untilExam_other": "距离考试还有{{count}}天",
			"isToday": "考试就在今天！"
		},
		"stats": {
			"mastery": "掌握度",
			"completed_one": "已作答项目",
			"completed_other": "已作答项目",
			"completedValue": "{{count}}",
			"xpEarned": "获得的 XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "准确率",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "您的{{skill}}预估水平为“{{level}}”",
			"itemsAnsweredTooltip": "您目前已作答的题目总数",
			"responsesAnsweredTooltip": "您目前已提交的作答总次数",
			"examDateTooltip": "你的考试日期为 {{date}}",
			"skillCta": {
				"diagnostic": "诊断",
				"practice": "练习"
			}
		},
		"menu": {
			"settings": "设置",
			"profile": "个人资料"
		},
		"diagnostics": {
			"title": "诊断",
			"free": "免费",
			"duration": "{{count}}个{{item}} • {{minutes}}分钟",
			"completed": "{{count}}个{{item}}已完成",
			"start": "开始",
			"viewReport": "查看报告",
			"resume": "继续"
		},
		"practiceTests": {
			"title": "模拟考试",
			"sectionalTestsTitle": "分项测试",
			"diagnosticAssessmentsTitle": "诊断评估",
			"premiumChipTooltip": "{{examName}}考试的全长高级模拟测试",
			"freeChipTooltip": "{{examName}}考试的{{label}}",
			"freeChipTooltipDefault": "{{examName}}考试的免费诊断评估",
			"completedDescription_one": "{{count}}道题 • {{date}}",
			"completedDescription_other": "{{count}}道题 • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}}道题 • 剩余{{timeRemaining}}",
			"activeDescription_other": "{{attempted}}/{{count}}道题 • 剩余{{timeRemaining}}",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}}道题 • 剩余{{timeRemaining}} • 开始于: {{startedOn}} • 结束于: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}}道题 • 剩余{{timeRemaining}} • 开始于: {{startedOn}} • 结束于: {{endsOn}}",
			"notStartedDescription_one": "{{count}}道题 • {{duration}}",
			"notStartedDescription_other": "{{count}}道题 • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}}道题 • {{duration}} • 结束于: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}}道题 • {{duration}} • 结束于: {{endsOn}}",
			"viewResultsCta": "查看结果",
			"startCta": "开始",
			"chips": {
				"items_one": "{{count}}道题",
				"items_other": "{{count}}道题",
				"progress_one": "{{attempted}}/{{count}}道题",
				"progress_other": "{{attempted}}/{{count}}道题",
				"timeRemaining": "剩余{{time}}",
				"startedOn": "开始于: {{date}}",
				"endsOn": "结束于: {{date}}",
				"timeLeft": "剩余{{time}}"
			},
			"status": {
				"notStarted": {
					"label": "未开始",
					"section": "全长模拟测试"
				},
				"inProgress": {
					"label": "进行中",
					"section": "进行中"
				},
				"completed": {
					"label": "已完成",
					"section": "已完成"
				},
				"legacyReports": {
					"label": "旧版报告",
					"section": "旧版报告"
				},
				"migratedReports": {
					"label": "已迁移报告",
					"section": "已迁移报告"
				}
			}
		},
		"skills": {
			"title": "技能",
			"unlockSubtitle": "解锁高级版以练习",
			"startCta": "练习",
			"freeItemsIncludedChip": "包含免费项目",
			"freeItemsAnsweredSubtitle_one": "免费项目{{count, number}}个中已作答{{answered, number}}个",
			"freeItemsAnsweredSubtitle_other": "免费项目{{count, number}}个中已作答{{answered, number}}个",
			"proficiencySection": "按熟练度练习",
			"progressCards": {
				"questionTypesTitle": "按题型表现",
				"questionTypesSubtitle": "{{skill}} 各题型得分情况",
				"proficiencyTitle": "按熟练度表现",
				"proficiencySubtitle": "{{skill}} 各级别进度",
				"questionTypeCardSubtitle": "按熟练度进度",
				"bySkillTitle": "按技能表现",
				"bySkillSubtitle": "各技能整体进度",
				"needsImprovementTitle": "待提升",
				"needsImprovementSubtitle": "下一步重点技能",
				"skillPerformanceTitle": "{{skill}} 表现",
				"skillPerformanceSubtitle": "按题型和熟练度的进度",
				"skillLevelSubtitle": "您在该技能层级的学习进度",
				"skillsPerformanceTitle": "技能表现",
				"performanceByItemDifficulty": "按题目熟练程度",
				"performanceByItemDifficultyCaption_one": "按熟练度显示您的正确率(基于已作答的 {{count}} 道题)",
				"performanceByItemDifficultyCaption_other": "按熟练度显示您的正确率(基于已作答的 {{count}} 道题)",
				"questionTypePartSubtitle": "{{skill}} · 第 {{part}} 部分",
				"activityGoalTitle": "活动与目标进度",
				"recentActivityTitle": "最近活动",
				"goalProgressTitle": "目标进度",
				"goalProgressSubtitle": "总体得分 · 最近 7 周",
				"goalProgressInsight": "你正在稳步提升。距离目标还差 14 分，预计约 3 周内可以达成。",
				"goalProgressActualLabel": "你的得分",
				"goalProgressTargetLabel": "目标",
				"goalProgressTimeAxisLabel": "时间",
				"goalProgressScoreAxisLabel": "总体进度",
				"statusTitle": "你的状态",
				"diagnosticsTitle": "诊断",
				"diagnosticsReviewCta": "查看",
				"strengthsFocusTitle": "优势与重点领域",
				"strengthsFocusSubtitle": "你的最强领域以及需要加强练习的题型",
				"strengthsLabel": "优势",
				"focusAreasLabel": "重点领域",
				"recommendedNextStepLabel": "推荐的下一步",
				"recommendedNextStepCta": "开始",
				"practiceTestsViewMore": "查看全部 {{count}} 个测试"
			}
		},
		"recommendedTasks": {
			"sectionTitle": "为您推荐",
			"startSessionAction": "练习",
			"resumeAction": "继续",
			"reviewResultsAction": "查看结果",
			"startTestAction": "开始测试",
			"activeTestBody": "完成您正在进行的评估",
			"completedTestBody": "查看您的表现和答案",
			"diagnosticBody": "进行{{label}}以熟悉考试形式",
			"diagnosticDefaultLabel": "免费诊断",
			"practiceTestBody": "通过限时测试评估您的考试准备情况。",
			"sectionalTestBody": "参加有针对性的测试，练习你的{{skills}}技能。",
			"weakSkillTitle": "提升你的{{skill}}",
			"weakSkillBody": "{{questionType}}练习，侧重你尚未掌握的部分。",
			"strongSkillTitle": "保持{{skill}}敏锐",
			"strongSkillBody": "你在这里表现不错。快速练一组{{questionType}}来巩固。",
			"mixedSkillTitle": "完善你的{{skill}}",
			"mixedSkillBody": "涵盖{{questionTypes}}的混合练习，侧重你错过的部分。",
			"higherDifficultySkillTitle": "挑战{{proficiency}}",
			"higherDifficultySkillBody": "这一水平的{{questionType}}你已掌握。这些题再难一档。",
			"itemsChip_one": "{{count}}道题",
			"itemsChip_other": "{{count}}道题",
			"timeRemainingChip": "剩余{{minutes}}分钟",
			"timeRemainingChipCompact": "{{minutes}}分钟"
		},
		"itemTypes": {
			"answeredLabel_one": "已作答",
			"answeredLabel_other": "已作答",
			"answeredAll": "全部",
			"answeredPartial": "已作答{{answered}}道，共{{total}}道",
			"cardSubtitleComplete": "全部题目已作答",
			"cardSubtitlePartial": "已作答{{attempted}}道，共{{total}}道",
			"cardSubtitleResponses_one": "已作答{{count}}次",
			"cardSubtitleResponses_other": "已作答{{count}}次",
			"responsesLabel_one": "作答次数",
			"responsesLabel_other": "作答次数",
			"detail": {
				"skillLabel": "技能",
				"estimatedLevelLabel": "预估级别"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}}{{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}}{{label, lowercase}}",
			"responseCount_one": "已作答{{count, number}}次",
			"responseCount_other": "已作答{{count, number}}次"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "包含{{count, number}}个免费练习项目",
			"freeContentBannerTitle_other": "包含{{count, number}}个免费练习项目",
			"freeContentBannerBody": "随时练习{{skills}}的项目。升级以解锁完整学习包。",
			"freeContentBannerCta": "开始免费练习",
			"freeSampleBanner": {
				"body_one": "随时练习来自{{categories}}的精选项目。升级即可解锁另外 {{count, number}} 个项目。",
				"body_other": "随时练习来自{{categories}}的精选项目。升级即可解锁另外 {{count, number}} 个项目。",
				"moreTags": "另外 {{count, number}} 个{{label}}",
				"cta": "升级"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "看看你与其他人相比如何"
		},
		"home": {
			"title": "主页"
		},
		"podcasts": {
			"description": "收听由专家主讲的骨科播客。"
		},
		"more": {
			"title": "更多设置"
		}
	},
	"emptyState": {
		"progress": {
			"title": "没有学习进度",
			"subtitle": "当你学习时，你的进度会显示在这里",
			"cta": "现在学习"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "错误",
			"body": "会话创建失败，请重试"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "高级",
			"highIntermediate": "中级",
			"intermediate": "中级",
			"basic": "基础",
			"none": "未回答",
			"high": "已掌握",
			"medium": "接近掌握",
			"low": "需要练习"
		}
	},
	"leaderboard": {
		"you": "这是你",
		"periods": {
			"all_time": "所有时间",
			"month": "本月",
			"week": "本周"
		},
		"scope": {
			"global": "全球",
			"friends": "好友"
		},
		"friends": {
			"soon": "即将上线",
			"comingSoonTitle": "好友排行榜",
			"comingSoonBadge": "即将推出",
			"comingSoonDescription": "与好友比拼进度，看看谁能登顶排行榜。"
		},
		"error": {
			"title": "连接错误",
			"description": "无法加载排行榜。请检查网络连接后重试。",
			"tryAgain": "重试"
		},
		"empty": {
			"title": "暂无排名",
			"description": "快来学习，抢占排行榜榜首。",
			"startLearning": "开始学习"
		},
		"topPerformers": "表现最佳",
		"yourPosition": "你的排名",
		"rankings": "排名",
		"rankingsRange": "排名 • 第{{startRank}}–{{endRank}}名",
		"unranked": {
			"title": "赚取经验值进入排名！",
			"description": "开始一次学习会话，获得首次积分并登上排行榜。",
			"cta": "开始第一次会话"
		},
		"xpAmount": "<num>{{value}}</num> <unit>经验</unit>",
		"youBadge": "你",
		"podium": {
			"first": "第1名",
			"second": "第2名",
			"third": "第3名"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit>经验</unit> <rest>即可超过第{{rank}}名</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit>经验</unit> <rest>距领奖台</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "课程",
			"statusFilter": {
				"all": "全部",
				"inProgress": "进行中",
				"notStarted": "未开始",
				"completed": "已完成"
			},
			"card": {
				"openCta": "打开",
				"resumeCta": "继续",
				"viewResultsCta": "查看结果",
				"duration_one": "{{count}} 分钟",
				"duration_other": "{{count}} 分钟"
			},
			"viewToggle": {
				"list": "列表视图",
				"grid": "网格视图"
			},
			"empty": {
				"filteredTitle": "没有符合此筛选条件的课程",
				"filteredSubtitle": "试试其他状态筛选",
				"filteredCta": "显示全部",
				"noneTitle": "未找到课程",
				"noneSubtitle": "请尝试移除筛选或重新搜索",
				"noneCta": "全部重置"
			}
		},
		"home": {
			"hero": {
				"greeting": "欢迎，{{name}}！",
				"greetingNoName": "欢迎！"
			},
			"stats": {
				"modulesDone": "已完成模块",
				"dayStreak": "连续天数",
				"minutesToday": "今日分钟数"
			},
			"suggested": {
				"title": "为你推荐",
				"openModuleCta": "打开模块",
				"status": {
					"ready": "准备就绪",
					"next": "下一个"
				}
			},
			"all": {
				"title": "全部课程"
			},
			"emptyState": {
				"title": "暂无课程",
				"subtitle": "敬请期待新课程。"
			},
			"card": {
				"duration_one": "{{count}} 分钟",
				"duration_other": "{{count}} 分钟"
			}
		},
		"overview": {
			"header": {
				"title": "概览"
			},
			"startCta": "开始学习",
			"objectives": {
				"title": "学习目标"
			}
		},
		"detail": {
			"takeQuizCta": "开始测验",
			"progress": {
				"label": "模块进度"
			},
			"activities": {
				"title": "活动",
				"completedCount": "已完成 {{completed}}/{{total}}"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "进度洞察"
			},
			"milestones": {
				"title": "模块里程碑",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "已读"
			},
			"readTime": "阅读时长 {{count}} 分钟",
			"sectionBadge": {
				"label": "第 {{number}} 节，共 {{total}} 节"
			},
			"upNext": {
				"title": "接下来"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "自定义学习课程",
		"diagnostic": "诊断",
		"skill": "技能",
		"Proficiency": "熟练度",
		"Question Type": "题型",
		"mastery": "掌握程度",
		"sessionLength": "学习时长",
		"itemsChip_one": "{{count}} 道题",
		"itemsChip_other": "{{count}} 道题",
		"durationEstimate": "{{minutes}} 分钟",
		"durationRange": "{{min}}–{{max}} 分钟",
		"noItemsTooltip": "没有符合当前筛选条件的题目",
		"setCount": "{{count}} {{type}}",
		"dismiss": "确定",
		"status": {
			"notAnswered": "未回答",
			"needsWork": "需要练习"
		},
		"itemCount": "您将完成{{topics}}个主题的{{count}}个题目",
		"start": "开始",
		"configuringSession": "正在配置会话...",
		"fetchingContent": "正在获取内容...",
		"preparingMaterials": "正在准备材料...",
		"almostThere": "即将完成...",
		"startingSession": "正在开始会话...",
		"playIcon": "play-outline",
		"infoText": "您将完成**{{numItems}}**个{{itemCount}}。这将花费大约**{{timeString}}**。",
		"customSummary": {
			"message": "学习{{topics}}中的$t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})。",
			"messageWithMastery": "学习{{topics}}中的$t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})，重点关注{{masteryLevels}}$t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}})。",
			"messageAllMasteryLevels": "学习{{topics}}中所有掌握程度的$t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})。",
			"itemCount_one": "{{count}}个题目",
			"itemCount_other": "{{count}}个题目",
			"masteryLevelCount_one": "掌握程度",
			"masteryLevelCount_other": "掌握程度",
			"allTopics": "全部{{count}}个主题",
			"more": "另外{{count}}个主题",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "快速学习",
			"recommended": "推荐",
			"custom": "自定义",
			"selectHelper": "点选一个会话，然后开始学习。",
			"emptyRecommended": "当前没有可用的推荐会话。",
			"summary": "学习{{count}}个{{skill}}题目。预计{{minutes}}分钟。",
			"summary_questionType": "学习{{count}}个{{skill}}、{{questionType}}题目。预计{{minutes}}分钟。",
			"duration": "{{minutes}}分钟",
			"durationSelector": {
				"title": "时长"
			},
			"levelSessions": {
				"rapidRecall": "快速回忆",
				"purposefulPractice": "针对性练习",
				"focusFlow": "专注冲刺",
				"itemsLabel": "{{level}}题目",
				"itemsLabelGeneric": "题目",
				"summaries": {
					"rapidRecall": "快速接触{{count}}个尚未作答的{{level}}题目，稳步扩大练习覆盖面。预计{{minutes}}分钟。",
					"purposefulPractice": "均衡学习{{count}}个{{level}}题目，从最需要加强的内容开始。预计{{minutes}}分钟。",
					"focusFlow": "集中攻克{{count}}个掌握程度较低的{{level}}题目，巩固薄弱环节。预计{{minutes}}分钟。"
				},
				"summariesGeneric": {
					"rapidRecall": "快速接触{{count}}个尚未作答的题目，稳步扩大练习覆盖面。预计{{minutes}}分钟。",
					"purposefulPractice": "均衡学习{{count}}个题目，从最需要加强的内容开始。预计{{minutes}}分钟。",
					"focusFlow": "集中攻克{{count}}个掌握程度较低的题目，巩固薄弱环节。预计{{minutes}}分钟。"
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "为了让您的学习体验更加个性化，请先做一次诊断测试。诊断结果将用于制定您的学习计划。"
	},
	"premium": {
		"chip": "高级版",
		"upgrade": "升级到高级版",
		"unlockTitle": "解锁完整的 {{productName}} 体验",
		"unlockDescription": "解锁根据您剩余学习时间设计的个性化练习。",
		"readyTitle": "为您{{date}}的考试做好准备",
		"tip": "您的个性化重点:高级版会确定接下来要练习的内容,并随着您的进步调整学习计划。"
	},
	"purchase": {
		"success": {
			"headerTitle": "感谢您的购买！",
			"accessGranted": "您已成功获得{{name}}的访问权限",
			"studyPack": "学习包",
			"practiceTest": "模拟测试",
			"combo": "组合",
			"documentTitle": "购买",
			"summary_one": "恭喜！以下**产品**已在您的账户上解锁。按{{action}}后，应用上下文将更改为反映考试：**{{examName}}**。如果您希望学习其他考试或购买其他产品，可以随时在账户设置中更改。",
			"summary_other": "恭喜！以下 **{{count}} 个产品** 已在您的账户上解锁。按{{action}}后，应用上下文将更改为反映考试：**{{examName}}**。如果您希望学习其他考试或购买其他产品，可以随时在账户设置中更改。",
			"unlockedDuration": "恭喜！您已解锁 **{{name}}** 的 **{{duration}}** 访问权限，将于 **{{expiry}}** 到期。",
			"storeNote": "注意：学习包仅可通过我们的移动应用使用。请下载适用于您设备的应用。",
			"actions": {
				"goToHome": "前往首页",
				"startDiagnostic": "开始{{label}}",
				"takeDiagnostic": "参加{{label}}",
				"takeFreeDiagnostic": "参加免费诊断测试",
				"diagnosticLabel": "诊断测试"
			}
		},
		"checkout": {
			"headerTitle": "完成您的购买"
		},
		"paywall": {
			"studyPackDialogTitle": "升级你的学习计划",
			"defaultDialogTitle": "升级你的学习计划",
			"practiceTestDialogTitle": "解锁模拟考试",
			"restorePurchaseDialogTitle": "已经购买？",
			"restorePurchaseDialogSubheadingWeb": "如果没有，请尝试以下方法：",
			"restorePurchaseDialogBody": "如果您已购买此产品但仍处于锁定状态，请尝试以下方法：\n\n1. 确认您登录的是正确的账户\n2. 确认您选择了正确的产品\n3. 确认您的订阅尚未过期\n4. 确认您已激活订阅（请查看垃圾邮件）\n5. 如果您有访问码，[访问码]({{baseUrl}}/redeem)\n\n如果以上均不适用，请**点击此处**",
			"restorePurchaseDialogBodyWeb": "1. 确认您登录的是正确的邮箱\n2. 确认**[已选择正确的考试](/account/settings)**\n3. 确认您的订阅尚未过期\n\n如果以上均不适用，请**联系支持团队**",
			"accesDuration": {
				"yearPlan": "**{{duration}}**计划提供延长访问权限，让您可以灵活地按照自己的节奏学习，并全面准备考试。",
				"moreTime": "如果您认为需要更多时间学习，可以考虑**{{duration}}**计划。",
				"otherPlan": "**{{duration}}**计划将授予您访问权限直到**{{expiryText}}**，这给您足够的时间学习。{{moreTime}}"
			},
			"actions": {
				"upgrade": "升级",
				"unlock": "{{price}} 解锁",
				"subscribe": "{{price}} 订阅",
				"extendAccess": "延长访问权限",
				"accessHere": "在此访问",
				"redeemAccessCode": "有访问码？",
				"restorePurchase": "已经购买？",
				"restorePurchaseWeb": "已经购买或拥有访问码？"
			},
			"subscriptionSummary": {
				"yearly": "年度订阅 • 自动续订 • 随时取消",
				"monthly": "每月订阅 • 自动续订 • 随时取消",
				"weekly": "每周订阅 • 自动续订 • 随时取消",
				"generic": "自动续订订阅 • 随时取消"
			},
			"planDuration": {
				"day_one": "{{count}}天",
				"day_other": "{{count}}天",
				"week_one": "{{count}}周",
				"week_other": "{{count}}周",
				"month_one": "{{count}}个月",
				"month_other": "{{count}}个月",
				"year_one": "{{count}}年",
				"year_other": "{{count}}年"
			},
			"recommendedPlan": {
				"plan": "我们建议选择**{{duration}}**计划，为您**{{date}}**的考试做好充分准备",
				"subscription": {
					"yearly": "我们建议选择**年度订阅**，持续获得访问权限，为您**{{date}}**的考试做好准备",
					"monthly": "我们建议选择**每月订阅**，持续获得访问权限，为您**{{date}}**的考试做好准备",
					"weekly": "我们建议选择**每周订阅**，持续获得访问权限，为您**{{date}}**的考试做好准备",
					"generic": "我们建议选择**订阅**，持续获得访问权限，为您**{{date}}**的考试做好准备"
				}
			},
			"disclaimer": "确认购买后，您将在所选期限内获得该产品内容的完整访问权限。该期限结束后，您将失去对受限内容的访问权限。如果出于任何原因（例如您更改了考试日期）需要延长访问权限，可以通过额外的应用内购买来增加时间。有关更多信息，请参阅我们的[服务条款和隐私政策](https://memorang.com/legal)。"
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "基于{{numItems}}个{{item}}已作答，跨越{{count}}个{{type}}",
			"itemCount": "{{count}}个{{item}}",
			"tooltip": "这显示了你在{{count}}个{{type}}中的进度。它基于你目前已作答的{{itemCount}}个{{item}}。"
		},
		"needsImprovement": {
			"title": "需要改进",
			"subtitle": "推荐{{type}}以提高",
			"cta": "开始学习"
		},
		"mastery": {
			"high": "已掌握",
			"medium": "接近掌握",
			"low": "需要练习",
			"count": "{{count}}个{{item}}已作答",
			"zeroTooltip": "在已作答的{{total}}个项目中，还没有{{label}}的项目",
			"highTooltip": "在已作答的{{total}}个{{item}}中，你已掌握{{count}}个",
			"mediumTooltip": "在已作答的{{total}}个{{item}}中，你有{{count}}个正在进步",
			"lowTooltip": "在已作答的{{total}}个{{item}}中，有{{count}}个需要更多练习"
		},
		"stats": {
			"completion": "完成度",
			"completionCount": "{{completed}}/{{total}}个{{item}}",
			"completionTooltip": "你已完成{{total}}个{{item}}中的{{completed}}个"
		},
		"exams": {
			"title": "模拟考试",
			"subtitle_one": "基于已完成的{{count}}次评估",
			"subtitle_other": "基于已完成的{{count}}次评估"
		},
		"summary": {
			"title": "学习概要",
			"subtitle": "基于{{count}}个{{item}}已作答",
			"tooltip": "这个总结显示了你在{{count}}个{{item}}中的掌握度和完成进度。你的表现是通过练习、评估和学习活动来衡量的。",
			"mastery": "掌握度",
			"quickStats": "快速统计"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}}熟练度",
			"proficiencyCardTooltip": "您目前的{{skill}}水平为“{{level}}”",
			"itemTypesCardSubtitle_one": "{{count}}种题型",
			"itemTypesCardSubtitle_other": "{{count}}种题型",
			"itemTypesCardTitle": "{{skill}}题目",
			"itemTypeLevelTooltip": "在“{{itemType}}”题型中，您目前的{{skill}}水平为“{{level}}”",
			"itemTypesFallbackTitle": "题型",
			"itemTypesEmptyTitle": "暂无题型数据",
			"itemTypesEmptySubtitle": "未找到该技能的题型数据。请返回进度页面重试。",
			"itemTypesEmptyCta": "返回进度",
			"notAnswered": "未作答",
			"answeredSubtitle_one": "基于已作答的{{count}}道题",
			"answeredSubtitle_other": "基于已作答的{{count}}道题",
			"responsesSubtitle_one": "基于{{count}}次作答",
			"responsesSubtitle_other": "基于{{count}}次作答",
			"testsTakenSubtitle_one": "基于已完成的{{count}}次测试",
			"testsTakenSubtitle_other": "基于已完成的{{count}}次测试",
			"startFirstTest": {
				"title": "开始吧",
				"itemsSubtitle_one": "{{count}} 道题",
				"itemsSubtitle_other": "{{count}} 道题",
				"guidance": {
					"diagnostic": "先做一次诊断测试，了解你的优势并调整学习计划。",
					"sectional": "分项测试只针对考试的一个部分，因此可以用更短的作答时间获得成绩。",
					"fullMock": "全真模拟测试完整还原真实考试，能给出最完整的成绩。"
				}
			},
			"noScoresTitle": "暂无{{skill}}成绩",
			"noScoresSubtitle": "完成第一次测试即可查看预估成绩和任务细分。",
			"noScoresCta": "开始",
			"noScoresCardSubtitle": "基于你参加的测试",
			"personalBestLabel": "个人最佳成绩",
			"latestLabel": "最新成绩",
			"examCountdown_one": "距离考试还有{{count}}天",
			"examCountdown_other": "距离考试还有{{count}}天",
			"greeting": {
				"none": "开始学习吧，{{firstName}}！🚀",
				"low": "开局不错，{{firstName}}，继续加油！💪",
				"medium": "继续保持，{{firstName}}！💪",
				"high": "就快到了，{{firstName}}！🎯"
			},
			"greetingNoName": {
				"none": "开始学习吧！🚀",
				"low": "开局不错，继续加油！💪",
				"medium": "继续保持！💪",
				"high": "就快到了！🎯"
			},
			"stats": {
				"untilExam": "考试日期",
				"itemsAnswered": "已作答题数",
				"responsesAnswered": "作答次数"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "错误的验证码",
		"incorrectPassword": "密码错误，请重试。",
		"passwordPlaceholder": "输入密码",
		"emailPlaceholder": "例如，dave@gmail.com",
		"verify": {
			"openEmail": "打开邮箱以继续",
			"signInCta": "验证您的账户...",
			"signUpCta": "创建您的账户...",
			"contactSupport": "没有收到邮件？请检查垃圾邮件文件夹或",
			"contactSupportLink": "联系我们",
			"resendMagicLink": "重发魔法链接",
			"resendMagicLinkIn": "{{time}}后可重发魔法链接",
			"signInBody": "您快完成了！验证您的详细信息以安全登录到{{appName}}应用。",
			"signUpBody": "您快完成了！验证您的详细信息以创建您的{{appName}}应用账户。",
			"magicLinkEmail": "我们已发送一个魔法链接至**{{email}}**\n点击邮箱中的链接以安全登录。",
			"magicLinkEmailExpiry": "此链接将在10分钟后过期",
			"confirmEmail": "确认您的邮箱",
			"redirectingToApp": "重定向到{{appName}}应用...",
			"appNotOpen": "应用未打开？点击下方按钮以打开关联的应用",
			"openApp": "打开{{appName}}应用",
			"installAppPrompt": "如果没有任何反应，请确保您已在设备上安装{{appName}}应用",
			"verifyAccountTitle": "验证您的账户",
			"emailResent": "我们已发送邮件，请查看您的邮箱，包括垃圾邮件或垃圾邮件文件夹",
			"verificationLinkExpired": "验证链接已过期",
			"verificationLinkExpiredBody": "验证链接在10分钟后过期，且只能使用一次。您可以再次登录以请求新的链接",
			"accountSetupTimeoutTitle": "无法完成登录",
			"accountSetupTimeoutBody": "您的账户设置时间超出预期。请重试登录，如问题持续请联系支持团队。",
			"loginAgain": "再次登录",
			"contactSupportExpiredLink": "如果此问题继续存在，请告诉我们",
			"successTitle": "您已在另一个标签页中登录",
			"successBody": "关闭此标签页，或从这里继续",
			"successCtaLabel": "在此继续",
			"needHelpLabel": "需要帮助？",
			"contactSupportButton": "联系支持"
		},
		"contactSupportDialog": {
			"title": "登录遇到问题？",
			"body": "如果您在登录时遇到问题，请联系我们的客户支持或重试",
			"cta": "发送邮件"
		},
		"emailInstruction": {
			"default": "如果您没有收到邮件，请检查您的垃圾邮件、废件箱和最近删除的文件夹",
			"edu": "如果您没有收到邮件，请检查您的垃圾邮件、废件箱和最近删除的文件夹，或联系您的IT管理员"
		},
		"createSessionLoader": {
			"configuringSession": "正在配置会话",
			"analyzingMastery": "正在分析掌握程度",
			"loadingContent": "正在加载内容"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "我们该如何称呼您？",
				"description": "您的姓名和头像会显示在仪表盘、报告和排行榜中。",
				"usernameLabel": "用户名",
				"firstNameLabel": "名",
				"lastNameLabel": "姓",
				"avatarLabel": "头像",
				"avatarTooltip": "头像会根据您的用户名自动生成。",
				"profileSaveFailed": "无法保存您的个人资料。请重试。"
			},
			"testDate": {
				"cta": "继续"
			},
			"examDate": {
				"daysAway": "这给了我们 {{value}} 天。我们将立即优先关注您最薄弱的领域。"
			},
			"skills": {
				"chooseAll": "请选择所有适用的选项"
			},
			"plan": {
				"recommended": "推荐"
			},
			"toeicLevelOverview": {
				"title": "每个人都有起点。",
				"description": "通过练习在当前级别打好基础，你会自然而然地成长到下一个级别。",
				"illustrationLabel": "从基础级（A1–A2）到中级（B1–B2）再到精通级（C1）的成长路径。",
				"levels": {
					"basic": {
						"name": "基础级",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "中级",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "精通级",
						"band": "C1"
					}
				},
				"progression": {
					"title": "你将如何进步",
					"practiceSessions": "完成推荐的练习",
					"buildMastery": "在当前级别打好基础",
					"growToward": "持续向精通级迈进"
				},
				"levelDetails": {
					"title": "各级别的含义",
					"scoreRange": "{{band}} · 分数 {{min}}–{{max}}",
					"basic": {
						"name": "基础级用户",
						"summary": "简单的职场英语",
						"examples": {
							"forms": "表格与通知",
							"instructions": "操作说明",
							"announcements": "简短通告"
						}
					},
					"intermediate": {
						"name": "中级用户",
						"summary": "日常职场沟通",
						"examples": {
							"emails": "邮件与对话",
							"customers": "客户互动",
							"followUps": "会议后续跟进"
						}
					},
					"proficient": {
						"name": "精通级用户",
						"summary": "专业与高阶英语",
						"examples": {
							"reports": "复杂报告与演示",
							"negotiations": "细致的谈判",
							"highStakes": "高风险的专业场合"
						}
					}
				},
				"disclaimer": "TOEIC Link 分数是与 CEFR 对应的参考标准，而非绝对分界线。阅读和听力分别进步，你在各项技能上可能达到不同级别。"
			},
			"review": {
				"diagnosticChoice": {
					"title": "诊断：{{title}}",
					"body": "通过 {{count}} 道题找出需要重点提升的领域",
					"duration": "{{minutes}} 分钟"
				},
				"homeChoice": {
					"title": "自行探索",
					"body": "我还没准备好开始，先探索一下应用"
				}
			}
		},
		"common": {
			"changeLater": "您可以随时更改此设置"
		},
		"actions": {
			"previous": "上一步",
			"finish": "完成",
			"start": "开始",
			"continue": "继续",
			"stepIndicator": "第 {{step}} 步，共 {{total}} 步"
		}
	},
	"more": {
		"profile": {
			"title": "关于你"
		},
		"exam": {
			"title": "你的考试"
		},
		"subscriptions": {
			"title": "产品",
			"redeem": {
				"title": "兑换购买"
			},
			"extend": {
				"cta": "延长"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "设置您的目标考试日期",
			"description": "此日期仅用于指导您在应用内制定学习计划，不会影响您的正式考试报名。",
			"dismissCta": "暂时不",
			"confirmCta": "设置考试日期"
		}
	},
	"account": {
		"title": "账户设置",
		"currentExam": "当前考试",
		"subscriptions": "产品",
		"examDate": "考试日期",
		"examDateUpdated": "考试日期已设为{{date}}",
		"selectDate": "选择日期",
		"appearance": "外观",
		"features": "功能",
		"audioPlaybackTest": "显示测试音频播放对话框",
		"theme": "主题",
		"selectTheme": "选择主题",
		"themeOptions": {
			"system": "系统",
			"light": "浅色",
			"dark": "深色"
		},
		"accountInfo": "账户",
		"username": "用户名",
		"name": "姓名",
		"nameNotSet": "未设置",
		"save": "保存",
		"editUsername": {
			"title": "编辑用户名"
		},
		"editName": {
			"title": "编辑姓名"
		},
		"email": "电子邮箱",
		"dev": "开发",
		"sandbox": "沙盒",
		"redoOnboarding": "重新进行引导",
		"about": "关于",
		"termsOfService": "服务条款",
		"privacyPolicy": "隐私政策",
		"aiToolsTos": "AI 工具使用条款",
		"support": "支持",
		"supportEmailBody": "我因以下问题需要您的帮助：[  ]\n\n\n\n以下是有助于更快解决问题的有用信息：\n\n与账户关联的用户名（在登录应用后在设置中可以找到）：\n{{username}}\n\n与订单关联的邮箱（在登录应用后在设置中可以找到）：\n{{email}}\n\n订单号（通常在购买时触发的收据邮件中可以找到）：\n\n购买产品时是否可能使用了不同的姓名或邮箱？如果是，请提供：\n\n姓名：\n\n邮箱：",
		"contactSupport": "联系支持",
		"signOut": "退出登录",
		"signOutConfirmation": "您确定要退出登录吗？",
		"deleteAccount": "删除账户",
		"platform": "平台",
		"partnerships": "合作伙伴",
		"validUntil": "有效期至{{date}}",
		"extendValidity": "延长访问",
		"redeemPurchase": "兑换购买",
		"redeemPurchaseNoneFound": "没有可兑换的购买",
		"redeemPurchaseCheckFailed": "无法检查购买记录，请重试。",
		"purchases": "购买",
		"frequentlyAskedQuestions": "常见问题",
		"deleteFeedbackForm": {
			"placeholder": "反馈"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "数据不足",
		"proficiencyLevelPendingTooltip": "回答更多{{label}}题目以预估您的水平",
		"on": "在",
		"gotIt": "知道了",
		"goBack": "返回",
		"unlock": "解锁",
		"topic": "主题",
		"itemCount_one": "{{count, number}}个项目",
		"itemCount_other": "{{count, number}}个项目",
		"examCount_one": "{{count}}个考试",
		"examCount_other": "{{count}}个考试",
		"questionCount_one": "{{count}}道题",
		"questionCount_other": "{{count}}道题",
		"item_one": "项目",
		"item_other": "项目",
		"and": "和",
		"this": "这个",
		"of": "之",
		"knowMore": "了解更多",
		"proficiency": "掌握度",
		"didNotAnswer": "您尚未作答的项目",
		"notAnswered": "未回答",
		"attempted": "尝试",
		"attempt": "尝试",
		"activity": "练习",
		"performance": "表现",
		"estimatedProficiency": "预计掌握度",
		"details": "详情",
		"keepPracticing": "继续练习——你做得很好！",
		"leaveFeedback": "留下反馈",
		"copiedToClipboard": "已复制到剪贴板",
		"eg": "例如",
		"set": "组",
		"hint": "提示",
		"itemType": "项目类型",
		"minute": "分钟",
		"minutes": "分钟",
		"hour": "小时",
		"hours": "小时",
		"continue": "继续",
		"cancel": "取消",
		"view": "查看",
		"switch": "切换",
		"update": "更新",
		"ok": "确定",
		"yes": "是",
		"free": "免费",
		"answered": "已回答",
		"correct": "正确",
		"incorrect": "错误",
		"marked": "已标记",
		"unmarked": "未标记",
		"skipped": "已跳过",
		"skill_one": "技能",
		"skill_other": "技能",
		"word_one": "字",
		"word_other": "字",
		"submitResponse": "提交回答",
		"viewDetails": "查看详情",
		"sec_one": "秒",
		"sec_other": "秒",
		"point_one": "分",
		"point_other": "分",
		"week": "周",
		"month": "月",
		"year": "年",
		"day": "天",
		"selectTestDate": "选择考试日期",
		"points": "分",
		"viewAll": "查看全部",
		"timeline": "时间轴",
		"save": "保存",
		"filters": {
			"selectAll": "全选",
			"deselectAll": "取消全选",
			"selectedCount": "已选择 {{count}} 项",
			"expandSection": "展开{{section}}",
			"collapseSection": "收起{{section}}"
		},
		"showMore": "展开更多",
		"showLess": "收起",
		"expandA11yLabel": "展开描述",
		"collapseA11yLabel": "收起描述",
		"done": "完成",
		"clearAll": "清除全部",
		"clear": "清除",
		"datePicker": {
			"title": "选择日期",
			"enterDateLabel": "输入日期",
			"enterDateRangeLabel": "输入日期范围",
			"dateLabel": "日期",
			"startDateLabel": "开始日期",
			"endDateLabel": "结束日期",
			"dateRequiredError": "请输入日期",
			"invalidDateFormatError": "日期格式无效，请使用 MM/DD/YYYY",
			"startAfterEndError": "开始日期不能晚于结束日期",
			"endBeforeStartError": "结束日期不能早于开始日期",
			"minDateError": "日期必须为 {{date}} 或之后",
			"maxDateError": "日期必须为 {{date}} 或之前",
			"dateRangeError": "日期必须在 {{startDate}} 至 {{endDate}} 之间",
			"setDateCta": "设置日期",
			"nextCta": "下一步",
			"setTimeCta": "设置时间"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}}的学习者选择了此答案。",
		"choiceCorrectA11yLabel": "正确答案",
		"choiceIncorrectA11yLabel": "错误答案",
		"choiceNotSelectedA11yLabel": "未选择",
		"moreItemsAlertDialog": {
			"title": "额外题目",
			"cta": "知道了"
		},
		"results": {
			"followUps": {
				"title": "后续问题"
			},
			"summary": {
				"sessionAnalysis": "会话分析",
				"itemCount_one": "{{count}} 道题",
				"itemCount_other": "{{count}} 道题",
				"skilledItemCount_one": "{{count}} 道{{skills}}题",
				"skilledItemCount_other": "{{count}} 道{{skills}}题",
				"levelPhrase_one": "{{levels}}级别的",
				"levelPhrase_other": "{{levels}}级别的",
				"message": "<bold>做得好！</bold>你刚刚在 {{timeTaken}} 内完成了 {{itemPhrase}}。",
				"messageWithLevels": "<bold>做得好！</bold>你刚刚在 {{timeTaken}} 内完成了 $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}){{itemPhrase}}。",
				"proficiencyEstimateReady": "您预估的{{skill}} 水平为 <bold>{{currentLevel}}</bold>。您已准备好挑战 <bold>{{nextLevel}}</bold>。",
				"proficiencyEstimateKeepPracticing": "您预估的{{skill}} 水平为 <bold>{{currentLevel}}</bold>。继续练习，然后再挑战 <bold>{{nextLevel}}</bold>。",
				"proficiencyEstimateHighest": "您预估的{{skill}} 水平为 <bold>{{currentLevel}}</bold>。出色的表现！",
				"mixedLevel": "混合",
				"overallScore": "总分",
				"stats": {
					"itemsAttempted_one": "已作答题目",
					"itemsAttempted_other": "已作答题目",
					"pointsEarned_one": "获得积分",
					"pointsEarned_other": "获得积分",
					"answeredCorrectly": "答对题目",
					"timeTaken": "所用时间",
					"target": "目标",
					"ofTotal": "共 {{total}} 题",
					"ofPointsTotal": "共 {{total}} 分",
					"skill": "技能",
					"skills": "技能",
					"questionType": "题型",
					"questionTypes": "题型",
					"proficiencyLevel": "水平等级",
					"proficiencyLevels": "水平等级"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "音频将在 {{seconds}} 秒后开始",
			"audioStartsInPlayOnce": "音频将在 {{seconds}} 秒后开始，仅播放一次",
			"videoStartsIn": "视频将在 {{seconds}} 秒后开始",
			"videoStartsInPlayOnce": "视频将在 {{seconds}} 秒后开始，仅播放一次",
			"recordingIn": "{{seconds}}秒后开始录音"
		},
		"timeOverrunBanner": {
			"message": "时间到。在真实考试中，此后的作答将不计分。您可以继续练习。"
		},
		"attributes": {
			"stimulus": "刺激"
		},
		"stimulusTypes": {
			"reading": "阅读",
			"listening": "听力",
			"speaking": "口语",
			"writing": "写作",
			"image": "图片"
		},
		"masteryLevels": {
			"belowBasic": "低于基础",
			"basic": "基础",
			"belowLowIntermediate": "低于低中级",
			"lowIntermediate": "低中级",
			"highIntermediate": "高中级",
			"advanced": "高级",
			"proficiencySubtitle": "在{{trademark}}中，这对应于**{{minScore}}-{{maxScore}}/30**的分数",
			"infoSectionLabel": "{{skill}} 部分信息",
			"infoSectionText": {
				"Reading": "{{trademark}} 阅读部分评估您阅读和理解学术材料的能力。它包括两篇阅读材料，每篇约700字，包含10道题目。完成阅读部分大约需要35分钟。",
				"Listening": "{{trademark}} 听力部分旨在测量您理解口语和讲座的能力。它包括听力材料，包括基本理解、理解说话者的态度和确定性以及连接信息。完成听力部分大约需要36分钟。",
				"Speaking": "{{trademark}} 口语部分测量您在学术环境中有效使用英语的能力。四个问题/任务类似于您可能在学校内外遇到的现实生活情况。完成口语部分大约需要16分钟。",
				"Writing": "{{trademark}} 写作部分测量您在学术环境中使用英语的能力。您将在计算机上输入您的回答，完成写作部分大约需要29分钟。"
			}
		},
		"itemTypes": {
			"MCSS": "单选题",
			"MCSSH": "单选高亮题",
			"MCMS": "多选题",
			"MCMSH": "多选高亮题",
			"INSERT_TEXT": "插入文本题",
			"MATCH_MS": "多项匹配题",
			"MCSSM": "单选匹配题",
			"MCMSM": "多选匹配题",
			"MCGS": "填空选择题",
			"MCOS": "排序选择题",
			"LISTENING_REPLAY": "听力重放题",
			"AUDIO_INPUT": "音频输入题",
			"ACADEMIC_DISCUSSION_RESPONSE": "学术讨论回应题",
			"INTEGRATED_WRITING_RESPONSE": "综合写作回应题"
		},
		"passageStem": {
			"itemOfTotal": "第 {{current}} 项/共 {{total}} 项",
			"questionOfTotal": "第 {{current}} 题/共 {{total}} 题",
			"stimulusCorrespondsToNextItems": "以下材料对应接下来的 {{total}} 道题",
			"passage": "段落",
			"lecture": "讲座",
			"professorsQuestion": "教授的问题",
			"listen": "听",
			"openPassage": "打开段落",
			"backToItem": "返回题目",
			"notYetInserted": "尚未插入",
			"insertedAtPosition": "插入位置 #{{position}}"
		},
		"hint": {
			"show": "显示提示"
		},
		"navigation": {
			"next": "下一个",
			"exit": "退出",
			"saveAndExit": "保存并退出",
			"previous": "上一个",
			"skip": "跳过",
			"finish": "完成",
			"help": "帮助",
			"about": "答题技巧",
			"questionsButtonLabel": "题目导航",
			"questionsButtonTooltip": "跳转到任何问题并查看回答、跳过和标记的项目。",
			"questionsButtonActiveFiltersA11y": "已选筛选：{{count}} 个",
			"recordingInProgressTooltip": "录音进行中，无法离开此题目",
			"questionNotReachedTooltip": "您尚未到达此题目"
		},
		"questionTips": {
			"hideFutureLabel": "不自动显示技巧"
		},
		"toolbar": {
			"calculatorTooltip": "打开计算器",
			"highlightTooltip": "选择文本以高亮重要信息，方便日后查阅",
			"markTooltip": "标记此题，以便在提交前回来复查",
			"unmarkTooltip": "点击以取消标记此题"
		},
		"summary": {
			"viewFullInsights": "查看完整洞察",
			"targetTooltip": "本次会话的表现目标。"
		},
		"stats": {
			"skill": "技能",
			"answered": "已回答",
			"speed": "速度",
			"duration": "录音时长",
			"duration_tooltip": "您录制回答的时长：{{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "信心",
			"pointsEarned": "积分",
			"word": "字",
			"words": "字数",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "您花了 {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) 阅读和回答这个问题",
			"skill_tooltip": "本题评估的技能领域：{{skill}}",
			"answered_correct_tooltip": "您提交的回答是正确的",
			"answered_incorrect_tooltip": "您提交的回答是错误的",
			"skipped_tooltip": "您未对本题提交回答",
			"words_tooltip": "书面回答的字数：{{count}}",
			"word_tooltip": "书面回答的字数：{{count}}",
			"confidence_tooltip": "提交回答时您选择的信心程度",
			"points_earned_tooltip_one": "本题满分 {{maximumScore}} 分，您获得了 {{points}} 分",
			"points_earned_tooltip_other": "本题满分 {{maximumScore}} 分，您获得了 {{points}} 分",
			"challengers_tooltip": "在您之前作答本题的学习者人数：{{count}}",
			"learning_mode_points_tooltip": "本次尝试获得的分数：+{{xp}} XP",
			"pts_earned_tooltip": "本次尝试获得的分数：{{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "展开细分"
		},
		"explanation": {
			"title": "解释",
			"feedback": "反馈",
			"skippedFeedbackNotice": "您跳过了此题，因此未生成个性化反馈。"
		},
		"followUps": "后续问题",
		"suggestCorrection": "建议修正",
		"answer": {
			"correct": "正确",
			"incorrect": "错误",
			"skipped": "已跳过"
		},
		"confidence": {
			"high": "高",
			"medium": "中",
			"low": "低"
		},
		"endDialog": {
			"title": "提前结束学习会话？",
			"confirmEndDiagnostic": "您确定要结束本次会话吗？所有进度将丢失，您需要重新开始。",
			"confirmEnd": "您还有 {{num}} {{itemLabel}} 未完成。您可以现在结束，也可以继续学习完成它们。",
			"confirmEndNoAnswer": "您还没有回答任何问题。您确定现在要结束吗？",
			"confirmEndNoAnswerPositive": "继续学习",
			"confirmEndNoAnswerNegative": "现在结束"
		},
		"permissionDialog": {
			"title": "需要麦克风权限",
			"descriptionWeb": "口语练习需要使用麦克风。浏览器已阻止此网站访问麦克风——请点击网址旁边的权限图标，允许使用麦克风后重试。",
			"descriptionMobile": "口语练习需要使用麦克风。请在设备设置中允许麦克风权限以继续。",
			"promptDescriptionWeb": "口语练习需要使用麦克风。请求权限后，在浏览器提示时选择「允许」。",
			"blockedDescriptionWeb": "此网站的麦克风访问已被阻止。请点击网址旁边的图标，允许使用麦克风，然后重新请求权限。",
			"ok": "好的",
			"cancel": "取消",
			"openSettings": "打开设置",
			"requestPermission": "请求权限",
			"dismissAndExit": "关闭并退出",
			"learnMore": "了解更多"
		},
		"audioPlaybackTestDialog": {
			"title": "测试音频播放",
			"description": "{{appName}} 包含多个音频播放功能，例如刺激、测试项目和文本转语音。为了确保最佳体验，请测试您的音频。一旦确认正常，请继续。",
			"troubleshooting": {
				"title": "音频问题故障排除",
				"volumeTitle": "检查设备音量",
				"volumeDescriptionWeb": "使用键盘控制或菜单/任务栏中的系统音量设置调节音量",
				"volumeDescriptionMobile": "使用设备音量按钮或在系统设置中调节",
				"outputTitle": "验证音频输出设备",
				"outputDescription": "如果使用耳机，请确保它们正确连接并被选为活动输出设备",
				"browserTitle": "检查浏览器标签页音频",
				"browserDescription": "查看标签页标题旁边是否有静音扬声器图标，如果有则取消静音"
			},
			"skipCheck": "下次跳过此检查",
			"workingButton": "确认音频正常",
			"textToHear": "你应该听到：{{text}}"
		},
		"overall": "总体",
		"subskills": {
			"content": {
				"title": "内容"
			},
			"languageUse": {
				"title": "语言运用"
			},
			"organizationAndDevelopment": {
				"title": "组织与发展"
			},
			"topicDevelopment": {
				"title": "主题发展"
			},
			"delivery": {
				"title": "表达"
			}
		},
		"finalizing": {
			"title": "正在生成您的成绩",
			"gradingProgress": "正在评分..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "口语任务，学习者需尽可能准确地复述听到的句子。",
			"Read Aloud": "口语题，学习者需朗读一段文字以接受评估。",
			"Describe Image": "口语任务，学习者需详细描述一幅图像。",
			"Write Essay": "写作任务，需就给定题目撰写一篇结构完整的作文。",
			"Retell Lecture": "口语任务，学习者需总结所听到的讲座或演讲内容。",
			"Summarize Group Discussion": "听力任务，学习者需总结多位说话者参与的讨论。",
			"Answer Short Question": "简短口语任务，学习者需简洁回答一个简短问题。",
			"Respond to a Situation": "口语任务，学习者需对所描述的情境作出恰当回应。",
			"Summarize Written Text": "阅读任务，学习者需用自己的话总结一段文字。",
			"Reorder Paragraph": "阅读任务，学习者需将打乱的段落排成正确顺序。",
			"Fill in the Blanks (Dropdown)": "阅读任务，学习者需从下拉选项中选择答案填入每个空格。",
			"Fill in the Blanks (Type In)": "听力任务，学习者需输入缺失的单词或短语。",
			"Fill in the Blanks (Drag and Drop)": "阅读任务，学习者需将选项拖动到空格中填入缺失的单词。",
			"Multiple Choice, Single Answer": "单选题，学习者需选择一个正确答案。",
			"Multiple Choice, Single Answer (Reading)": "阅读单选题，学习者需选择一个正确答案。",
			"Multiple Choice, Single Answer (Listening)": "听力单选题，学习者需选择一个正确答案。",
			"Multiple Choice, Multiple Answers": "多选题，学习者可选择多个正确答案。",
			"Multiple Choice, Multiple Answers (Reading)": "阅读多选题，学习者可选择多个正确答案。",
			"Multiple Choice, Multiple Answers (Listening)": "听力多选题，学习者可选择多个正确答案。",
			"Summarize Spoken Text": "听力任务，学习者需写出所听内容的摘要。",
			"Highlight Correct Summary": "听力任务，学习者需标出与音频内容最相符的摘要。",
			"Select Missing Word": "听力填空任务，学习者需选出缺失的单词。",
			"Highlight Incorrect Words": "听力任务，学习者需标出文字稿中与音频不符的单词。",
			"Write from Dictation": "听力任务，学习者需听写所听到的句子。"
		}
	},
	"report": {
		"readFullInsights": "阅读完整洞察",
		"productName": "{{examName}} {{type}}",
		"startedAt": "开始于 {{time}}",
		"itemTypesTitle": "题型明细",
		"itemTypesFilterAll": "全部",
		"questionTypeCardTitle": "{{skill}}题型明细",
		"questionTypeCardSubtitle_one": "基于本场会话中的 {{count}} 种{{skill}}题型",
		"questionTypeCardSubtitle_other": "基于本场会话中的 {{count}} 种{{skill}}题型",
		"questionTypeCardAltSubtitle_one": "基于本场会话中的 {{count}} 种题型",
		"questionTypeCardAltSubtitle_other": "基于本场会话中的 {{count}} 种题型",
		"questionTypeRowSubtitle_zero": "未作答任何题目",
		"questionTypeRowSubtitle_one": "已作答 {{count}} 题",
		"questionTypeRowSubtitle_other": "已作答 {{count}} 题",
		"itemTypeDetail": {
			"review_one": "查看题目",
			"review_other": "查看题目",
			"stats": {
				"answered_one": "已作答题目",
				"answered_other": "已作答题目",
				"avgTime": "每题平均用时"
			}
		},
		"reviewAnswersDialog": {
			"title": "查看答案",
			"sections": {
				"skills": "技能",
				"questionTypes": "题型",
				"proficiency": "熟练度",
				"performance": "表现"
			},
			"summaryNone": "请选择包含条目的筛选条件以继续。",
			"summaryAll_one": "查看全部 {{count}} 条回答。",
			"summaryAll_other": "查看全部 {{count}} 条回答。",
			"summaryFiltered_one": "查看符合 {{filters}} 的 {{count}} 条回答。",
			"summaryFiltered_other": "查看符合 {{filters}} 的 {{count}} 条回答。",
			"reviewAnswers_one": "查看 {{count}} 条回答",
			"reviewAnswers_other": "查看 {{count}} 条回答",
			"more": "还有 {{count}} 项"
		},
		"itemDetail": {
			"title": "查看我的答案",
			"filterAll": "全部",
			"filterCorrect": "正确",
			"filterIncorrect": "错误",
			"filterMarked": "已标记",
			"emptyTitle": "没有匹配的题目",
			"emptyDescription": "您的会话题目中没有与所选筛选（{{filter}}）匹配的项。请调整或清除筛选以查看更多结果。",
			"emptyCta": "清除筛选"
		},
		"answerCardTitle": "已作答题",
		"answerCardSubtitle_one": "查看所有题目的表现",
		"answerCardSubtitle_other": "查看全部 {{count}} 道题的表现",
		"skillsBreakdown": {
			"title": "技能细分",
			"subtitle_one": "基于 {{count}} 道题目",
			"subtitle_other": "基于 {{count}} 道题目"
		},
		"studyPack": "学习包",
		"practiceTestCompleted": "模拟测试完成",
		"studySessionCompleted": "学习课程完成",
		"diagnosticSessionCompleted": "诊断评估完成",
		"timeElapsed": "已用时间",
		"stats": {
			"answered": "已回答",
			"time elapsed": "已用时间",
			"avg speed": "平均速度",
			"hints used": "使用的提示"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "出色的表现——继续追求卓越！",
				"highIntermediate": "你做得很棒——继续磨练你的优势！",
				"lowIntermediate": "你的进步很稳定——继续保持！",
				"basic": "继续努力提升你的能力！"
			},
			"infoText": "您完成了 **{{numActivities}} {{activityLabel}}** 来练习您的 {{skillsText}} {{skills}}. {{skillDetails}}. 总体上，您获得了 **{{numPointsEarned}} 分**，表明您在 {{thisText}} {{skills}} 上的 **{{compositeLevel}} 水平**。{{compositeFeedback}}",
			"infoText.singleSkill": "您完成了 **{{itemCount}} {{itemLabel}}**，专注于您的 **{{skill_1}}** 技能。您获得了 **{{skill_1_score}} 分（总分 {{skill_1_total}} 分）**，表明您达到了 **{{proficiency}}** 水平。{{compositeFeedback}}",
			"infoText.multiSkill": "您完成了 **{{itemCount}} {{itemLabel}}**，练习了您的 **{{skills_text}}** 技能。{{skill_details}} 总体上，您获得了 **{{overall_score}} 分（总分 {{overall_total}} 分）**，表明您在这些技能上达到了 **{{overall_proficiency}}** 水平。{{compositeFeedback}}",
			"skillDetails": "在 **{{skill}}** 中，您获得了 **{{score}} 分（总分 {{total}} 分）**，表明 **{{proficiency}}** 水平。"
		},
		"actions": {
			"goToHome": "返回首页",
			"studyMore": "继续学习",
			"studyFree": "免费学习{{tagTypes}}",
			"reviewAnswers": "复习答案"
		},
		"nextAction": {
			"title": "推荐：{{focus}}练习",
			"dialog": {
				"title": "推荐学习课程",
				"subtitle": "专注于你的薄弱环节"
			},
			"fallback": {
				"title": "继续练习",
				"description": "围绕你接下来想练习的内容创建一个学习课程。"
			}
		},
		"premium": {
			"upgradeCta": "升级到高级版"
		},
		"disclaimer": {
			"title": "免责声明",
			"summativeBody": "练习测试成绩仅为预估，并不保证在正式 {{examName}} 考试中获得相同结果。"
		},
		"performance": {
			"title": "表现",
			"subtitle": "基于 {{count}} 个项目",
			"correct": "正确",
			"correctItems": "{{count}} 个项",
			"incorrect": "错误",
			"incorrectItems": "{{count}} 个项目"
		},
		"mastery": {
			"performanceTitle": "表现",
			"sessionMasteryTitle": "估计掌握度",
			"subtitle_assessment": "基于本次评估的全部{{count}}个{{item}}",
			"subtitle_session": "基于本次学习的全部{{count}}个{{item}}"
		},
		"sessionAnalysis": {
			"title": "会话分析",
			"subtitle": "个性化分析和建议",
			"viewFullAnalysis": "查看完整分析",
			"feedbackDialog": {
				"body": "我们几乎每天都在改进，我们决心改进。您愿意**留下反馈**吗？",
				"placeholder": "输入您的反馈",
				"cta": "发送反馈",
				"successMessage": "感谢您的反馈！",
				"feedbackLimitError": "反馈必须至少10个字符"
			},
			"menuActions": {
				"copy": "复制",
				"altCopy": "复制摘要文本",
				"altPositiveFeedback": "这很有帮助",
				"positiveFeedback": "好的回答",
				"negativeFeedback": "不好的回答",
				"reportIssue": "举报",
				"altReportIssue": "举报此回答",
				"emailSummary": "发送摘要",
				"emailAlreadySent": "已发送",
				"copiedAnalysis": "已复制分析到剪贴板",
				"emailSent": "已发送至 {{email}}，如果您没有收到电子邮件，请检查垃圾邮件、垃圾邮件和最近删除的文件夹，或联系您的IT管理员",
				"emailFailed": "发送失败至 {{email}}",
				"emailInstructionMessage": "如果您没有收到电子邮件，请检查垃圾邮件、垃圾邮件和最近删除的文件夹，或联系您的IT管理员"
			}
		}
	},
	"feedback": {
		"successMessage": "感谢您的反馈！"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "您喜欢什么？有什么可以改进的？我们每天都在改进平台，我们的团队阅读每一条反馈。谢谢！",
			"title": "分享您的反馈",
			"body": "您喜欢什么？有什么可以改进的？我们每天都在改进平台，我们的团队阅读每一条反馈。**谢谢！**",
			"positiveBody": "很高兴这对您有帮助！请告诉我们**您喜欢什么。**",
			"negativeBody": "帮助我们了解哪里出了问题，以便我们**改进回答。**",
			"placeholder": "输入反馈",
			"cta": "发送反馈"
		},
		"report": {
			"title": "提交报告",
			"body": "帮助我们了解这个回答有什么问题",
			"cta": "提交报告"
		},
		"suggestCorrection": {
			"title": "建议修正",
			"body": "帮助我们提高此内容的准确性，请**报告任何错误。**",
			"cta": "提交"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "不准确",
					"description": "回答包含不正确的信息"
				},
				"notHelpful": {
					"title": "没有帮助",
					"description": "回答没有解决我的问题"
				},
				"incomplete": {
					"title": "不完整",
					"description": "回答缺少重要的细节"
				},
				"hardToUnderstand": {
					"title": "难以理解",
					"description": "回答令人困惑或不清楚"
				},
				"other": {
					"title": "其他",
					"description": "其他原因"
				}
			},
			"report": {
				"misinformation": {
					"title": "虚假信息",
					"description": "回答包含虚假或误导性信息"
				},
				"harmfulContent": {
					"title": "有害或冒犯性内容",
					"description": "仇恨言论、骚扰或不当语言"
				},
				"violatesPolicies": {
					"title": "违反政策",
					"description": "垃圾信息、自我推广或非法内容"
				},
				"other": {
					"title": "其他",
					"description": "用您自己的话描述问题所在"
				}
			}
		},
		"faqs": {
			"title": "常见问题解答",
			"body": "这里有一些关于应用的常见问题。如果您有任何其他问题，请随时联系我们support@memorang.ai"
		},
		"delete": {
			"title": "删除账户",
			"body": "我们很遗憾看到您离开，祝您在学业和职业道路上一切顺利！",
			"options": "太贵了|已经参加了测试|不喜欢内容|缺少功能/功能性|其他",
			"confirmdelete": {
				"title": "确认删除账户",
				"cta": "删除",
				"errorMessage": "抱歉，该邮箱与该账户不匹配。请重试",
				"successMessage": "账户删除成功！",
				"validEmail": "请输入有效的邮箱地址"
			}
		}
	},
	"recorder": {
		"tapToRecord": "点击按钮开始录音",
		"responseAudioUnavailable": "回答音频无法播放",
		"recording": "录音中",
		"recordingCompleted": "录音完成",
		"getReady": "准备好",
		"timeIsUp": "时间到。您的回答未被录制。",
		"alert": {
			"title": "最大时长已达到",
			"body": "录音已停止，因为它已达到最大时长{{maxDuration}}秒。"
		},
		"uiElementPressed": "录音停止 - 在录音过程中打开刺激。"
	},
	"writing": {
		"placeholder": "在此处写下您的回答...",
		"wordCount": "{{count}} {{word}}",
		"title": "您的回答",
		"submit": "提交",
		"helper": {
			"range": "写 {{min}}–{{max}} 个单词以提交回答",
			"min": "至少写 {{min}} 个单词以提交回答",
			"max": "请将回答缩短至 {{max}} 个单词以内"
		}
	},
	"navbar": {
		"home": "主页",
		"progress": "进度",
		"insights": "洞察",
		"leaderboard": "领先者",
		"store": "商店",
		"more": "更多",
		"redeem": "兑换",
		"study-pack": "学习包",
		"podcasts": "播客",
		"modules": "模块",
		"account": "账户设置",
		"accountTab": "账户",
		"privacy": "隐私",
		"terms": "条款",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "代码输入正确但问题仍未解决？**联系支持团队**，并确保附上您的访问代码和购买详情",
		"olxDialog": {
			"unlockedTitle": "访问权限已解锁",
			"expiredTitle": "访问权限已过期",
			"testInfo": "**考试：** {{examName}} | **测试：** {{bundleName}}",
			"upcomingBody_one": "您对 OLX 测试的访问权限已解锁！\n\n您可以在 **{{count}} 天**后开始您的测试。请稍后从练习测试标签页返回以开始您的测试。",
			"upcomingBody_other": "您对 OLX 测试的访问权限已解锁！\n\n您可以在 **{{count}} 天**后开始您的测试。请稍后从练习测试标签页返回以开始您的测试。",
			"activeBody": "您对 OLX 测试的访问权限现已生效！\n\n您可以在 **{{date}}** 之前的任何时间开始测试。\n\n您想现在开始测试还是稍后再开始？",
			"expiredBody": "您对 OLX 测试的访问权限已于 **{{date}}** 过期。\n\n如需进一步帮助，请联系您的教授或学校管理员。",
			"startNowCta": "立即开始",
			"startLaterCta": "稍后开始"
		},
		"unexpectedError": "发生了意外错误。"
	},
	"redeemCode": {
		"titleRedeem": "兑换访问权限",
		"titleGranted": "访问权限已授予",
		"formTitle": "输入您的访问代码",
		"accessCodeHint": "如果您有访问代码，请在此处输入，包括破折号。",
		"submit": "兑换",
		"access": "在此访问",
		"helpFindCode": "需要帮助查找您的代码吗？",
		"troubleRedeeming": "兑换时遇到问题？问问助手！",
		"skipStep": "跳过此步骤"
	},
	"autoRedeem": {
		"redeem": "兑换",
		"redeeming": "兑换中...",
		"continue": "继续",
		"unredeemedPrompt_one": "与电子邮件地址 **{{email}}** 关联的 **{{count}} 个产品** 尚未兑换。是否将其添加到您的账户？",
		"unredeemedPrompt_other": "与电子邮件地址 **{{email}}** 关联的 **{{count}} 个产品** 尚未兑换。是否将它们添加到您的账户？",
		"successMessage_one": "恭喜！以下**产品**已在您的账户上解锁。按继续后，应用上下文将更改为反映考试：**{{examName}}**。如果您希望学习其他考试或购买其他产品，可以随时在账户设置中更改。",
		"successMessage_other": "恭喜！以下 **{{count}} 个产品** 已在您的账户上解锁。按继续后，应用上下文将更改为反映考试：**{{examName}}**。如果您希望学习其他考试或购买其他产品，可以随时在账户设置中更改。"
	},
	"olxEligibility": {
		"goToPracticeTests": "前往模拟测试"
	},
	"moreChallenges": {
		"challenges": "挑战",
		"challengesCount": "{{value}} 挑战"
	},
	"tts": {
		"tooltip": "听这段文字"
	},
	"commandBar": {
		"placeholder": "搜索...",
		"input": {
			"placeholder": "输入命令或搜索"
		},
		"sections": {
			"quickActions": "快捷操作"
		},
		"actions": {
			"changeExam": "更改考试",
			"switchToDarkMode": "切换到深色模式",
			"switchToLightMode": "切换到浅色模式",
			"setExamDate": "设置考试日期"
		}
	},
	"filterView": {
		"placeholder": "搜索考试..."
	},
	"transcript": {
		"show": "显示文字稿",
		"hide": "隐藏文字稿"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "应用图标",
			"testNameLabel": "测试名称",
			"sectionLabel": "部分",
			"back": "返回",
			"pause": "暂停",
			"menuLabel": "更多选项"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "测试进度",
			"of": "/",
			"pauseSession": "暂停会话",
			"timerTooltip": {
				"item": "本题剩余时间",
				"section": "本部分剩余时间",
				"test": "本次考试剩余时间"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "下一步"
		},
		"progressBar": {
			"timeLeftLabel": "本题剩余时间",
			"timeLeftForUnit": "本单元剩余时间",
			"questionOf": "第 {{current}} 题/共 {{total}} 题",
			"questionProgress": "<b>{{current}}</b>/共 {{total}} 题",
			"timesUp": "时间到",
			"statusTooltips": {
				"answered": "已作答",
				"inProgress": "进行中",
				"skipped": "已跳过",
				"notSeen": "未查看"
			}
		},
		"timeRemainingDialog": {
			"title": "您还有时间",
			"body": "本单元仍有剩余时间。您想在提交前检查您的答案吗？",
			"reviewCta": "检查我的答案"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "原始内容",
				"answerTitle": "你的答案",
				"remainingBadge": "剩余 {{count}}",
				"placedBadge": "已放置 {{count}}",
				"pointsBadge": "{{earned}}/{{max}} 分",
				"emptyHint": "从左侧面板拖动段落到这里"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "支持信息",
			"emailLabel": "邮箱",
			"subjectLabel": "主题",
			"messageBodyLabel": "消息正文",
			"appDetailsLabel": "应用详情",
			"appNameLabel": "名称",
			"versionLabel": "版本",
			"platformLabel": "平台"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} 支持助手",
			"fallbackTitle": "聊天",
			"betaWarning": "此 AI 助手处于**测试版**——回复偶尔可能不准确或不完整。",
			"greeting": "你好 👋 在获取产品访问权限时遇到问题了吗？我来帮您！首先，我们先来确定问题所在。以下哪一项最符合您的情况？\n\n1. 我有访问代码，但似乎无法使用。\n2. 我已购买，但找不到我的访问代码。\n3. 我本应通过学校获得访问权限，但找不到我的访问代码。\n4. 我之前拥有某产品的访问权限，但目前无法访问。\n\n请输入与您的问题对应的数字。",
			"input": {
				"label": "输入消息...",
				"sendLabel": "发送"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 兑换成功",
			"previouslyRedeemedTitle": "🚀 之前已兑换",
			"subtitle": "在此访问您的内容",
			"expires": "到期时间：{{date}}",
			"openCta": "打开"
		},
		"purchases": {
			"title": "🎉 已找到访问代码",
			"subtitle": "兑换以访问您的内容",
			"accessCodesLabel_one": "访问代码",
			"accessCodesLabel_other": "访问代码",
			"moreCodes_one": "（+ 还有 {{count}} 个）",
			"moreCodes_other": "（+ 还有 {{count}} 个）",
			"featuresLabel": "功能",
			"redeemCta": "兑换"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "新版本已发布，请点击刷新以更新。",
			"refreshCta": "刷新",
			"refreshA11yLabel": "刷新以更新应用",
			"dismissTooltip": "关闭",
			"dismissA11yLabel": "关闭更新通知"
		}
	},
	"cme": {
		"type": "CME 类型",
		"chooseExportMethod": "选择导出方法",
		"selectDateRange": "选择日期范围",
		"from": "从",
		"to": "到",
		"sendPdfTo": "将 PDF 发送到 {{email}}",
		"downloadCertificate": "下载证书为 PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "获得的 CME 学分",
		"confirmYourName": "确认您的姓名",
		"certificateNameNotice": "此姓名将印在您的 CME 证书上。",
		"firstName": "名",
		"lastName": "姓",
		"firstNamePlaceholder": "输入您的名",
		"lastNamePlaceholder": "输入您的姓",
		"confirm": "确认",
		"creditsEarnedTitle": "获得的 CME",
		"creditRatioCaption": "12 次挑战 = 1 CME 学分",
		"earned": "已获得",
		"available": "可用",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "导出 CME 证书",
		"exportDisabledCaption": "您需要获得至少 1 个 CME 学分才能导出您的证书",
		"viewDisclaimer": "查看 CME 免责声明"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "简介",
			"tagsHeading": "标签",
			"citationsHeading": "参考文献",
			"playing": "正在播放"
		},
		"a11y": {
			"artwork": "{{title}}的封面",
			"playEpisode": "播放本集，{{duration}}",
			"pauseEpisode": "暂停本集",
			"play": "播放",
			"pause": "暂停",
			"addToQueue": "加入队列",
			"removeFromQueue": "移出队列",
			"addBookmark": "收藏",
			"removeBookmark": "取消收藏",
			"seekBar": "进度条",
			"skipPrevious": "上一曲",
			"skipNext": "下一曲",
			"rewind": "后退{{seconds}}秒",
			"fastForward": "快进{{seconds}}秒",
			"playbackSpeed": "播放速度{{speed}}x"
		}
	}
}
